/// <reference types="react" />
import "VSS/LoaderPlugins/Css!fabric";
import "VSS/LoaderPlugins/Css!TestManagement/Scripts/Scenarios/AttachmentsGridView/ControllerViews/AttachmentsGridView";

import { IContextualMenuItem } from "OfficeFabric/ContextualMenu";
import { DetailsList, DetailsListLayoutMode, IColumn } from "OfficeFabric/DetailsList";
import { Fabric } from "OfficeFabric/Fabric";
import { MessageBar, MessageBarType } from "OfficeFabric/MessageBar";
import { TooltipHost } from "VSSUI/Tooltip";
import { IPopupContextualMenuProps, PopupContextualMenu } from "Presentation/Scripts/TFS/Components/PopupContextualMenu";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Resources from "TestManagement/Scripts/Resources/TFS.Resources.TestManagement";
import {
    AttachmentsGridViewActionsCreator,
} from "TestManagement/Scripts/Scenarios/AttachmentsGridView/Actions/AttachmentsGridViewActionsCreator";
import {
    IAttachmentDetails,
} from "TestManagement/Scripts/Scenarios/AttachmentsGridView/Actions/AttachmentsGridViewActionsHub";
import {
    AttachmentsGridViewStore,
    IAttachmentsGridViewState,
} from "TestManagement/Scripts/Scenarios/AttachmentsGridView/Stores/AttachmentsGridViewStore";
import * as ConfirmationDialog from "TestManagement/Scripts/Scenarios/Common/Components/ConfirmationDialog";
import { TelemetryService } from "TestManagement/Scripts/TFS.TestManagement.Telemetry";
import * as TMUtils from "TestManagement/Scripts/TFS.TestManagement.Utils";
import * as ComponentBase from "VSS/Flux/Component";
import { announce } from "VSS/Utils/Accessibility";
import * as Utils_Date from "VSS/Utils/Date";
import * as Utils_String from "VSS/Utils/String";
import * as Utils_UI from "VSS/Utils/UI";
import * as Utils_File from "VSS/Utils/File";
import * as TCMContracts from "TFS/TestManagement/Contracts";

export interface IAttachmentsGridViewProps extends ComponentBase.Props {
    actionsCreator: AttachmentsGridViewActionsCreator;
    store: AttachmentsGridViewStore;
    attachmentSource: string;
    testRunId: number;
    testResultId: number;
    subResultId: number;
}

export function renderGrid(element: HTMLElement, AttachmentsGridViewProps: IAttachmentsGridViewProps): void {
    ReactDOM.render(<AttachmentsGridView { ...AttachmentsGridViewProps } />, element);
}

export function unmountGrid(element: HTMLElement): void {
    ReactDOM.unmountComponentAtNode(element);
}

export class AttachmentsGridView extends ComponentBase.Component<IAttachmentsGridViewProps, IAttachmentsGridViewState> {

    private _columns: IColumn[];
    private _columnsForLogStore: IColumn[];

    constructor(props: any) {
        super(props);
        this._columns = this._getColumnsForDetailsList();
        this._columnsForLogStore = this._getColumnsForDetailsListForLogStore();
    }

    public componentWillMount(): void {
        this.props.actionsCreator.clearState();
        this._handleStoreChange();
        this.props.store.addChangedListener(this._handleStoreChange);
        this.props.actionsCreator.getAttachments(this.props.testRunId, this.props.testResultId, this.props.attachmentSource, this.props.subResultId);
    }

    public componentDidMount(): void {
        this.props.actionsCreator.initializeColums(this._columns);
        this.props.actionsCreator.initializeColumsForLogStore(this._columnsForLogStore);
    }

    public componentWillUnmount(): void {
        this.props.store.removeChangedListener(this._handleStoreChange);
    }



    public render(): JSX.Element {
        let { columns, attachments } = this.state;
        return (
            <Fabric
                className="test-attachments-grid-view"
            >
                <h2 className="attachments-header">
                    {Utils_String.format(Resources.AttachmentsLabel, (attachments) ? (attachments.getLegacyAttachments() && attachments.getLegacyAttachments().length) || ( attachments.getLogStoreAttachments() && attachments.getLogStoreAttachments().length) : 0)}
                </h2>
                {
                    this.state.errorMessage ?
                        <TooltipHost content={this.state.errorMessage}>
                            <MessageBar
                                messageBarType={MessageBarType.error}
                                dismissButtonAriaLabel={Resources.ClearErrorMessage}
                                className="preview-attachment-error-bar"
                                isMultiline={false}
                                onDismiss={this._onErrorMessageDismiss}>
                                {this.state.errorMessage}
                            </MessageBar>
                        </TooltipHost>
                        :
                        Utils_String.empty
                }
                {
                    this.state.attachments && this.state.attachments.getLegacyAttachments() && this.state.attachments.getLegacyAttachments().length > 0 &&
                        <DetailsList
                            className="attachments-grid"
                            items={this.state.attachments.getLegacyAttachments()}
                            ariaLabelForGrid={Resources.AttachmentsHeaderText}
                            ariaLabelForSelectionColumn={Resources.SelectAll}
                            getRowAriaLabel={(item) => item.name}
                            checkButtonAriaLabel={Resources.SelectRow}
                            compact={true}
                            columns={this._columns}
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.justified}
                            isHeaderVisible={true}
                            selection={this.state.selection}
                            selectionPreservedOnEmptyClick={false}
                            onItemContextMenu={this._onItemContextMenu}
                            onItemInvoked={(item) => this._onItemInvoked(item)}
                        />
                }
                {
                    this.state.attachments && this.state.attachments.getLogStoreAttachments() && this.state.attachments.getLogStoreAttachments().length > 0 &&
                        <DetailsList
                            className="attachments-grid"
                            items={this.state.attachments.getLogStoreAttachments()}
                            ariaLabelForGrid={Resources.AttachmentsHeaderText}
                            ariaLabelForSelectionColumn={Resources.SelectAll}
                            getRowAriaLabel={(item) => item.name}
                            checkButtonAriaLabel={Resources.SelectRow}
                            compact={true}
                            columns={this._columnsForLogStore}
                            setKey="set"
                            layoutMode={DetailsListLayoutMode.justified}
                            isHeaderVisible={true}
                            selection={this.state.logStoreSelection}
                            selectionPreservedOnEmptyClick={false}
                            onItemContextMenu={this._onItemContextMenu}
                            onItemInvoked={(item) => this._onItemInvoked(item)}
                        />
                }
            </Fabric>
        );
    }

    private _onColumnHeaderClick = (ev: any, column: IColumn) => {
        const { columns, attachments } = this.state;
        let newItems: TCMContracts.TestAttachment[] = attachments.getLegacyAttachments().slice();
        let newColumns: IColumn[] = this._columns.slice();
        let currentColumn: IColumn = newColumns.filter((currCol: IColumn, idx: number) => {
            return column.key === currCol.key;
        })[0];
        newColumns.forEach((newColumn: IColumn) => {
            if (newColumn === currentColumn) {
                currentColumn.isSortedDescending = !currentColumn.isSortedDescending;
                currentColumn.isSorted = true;
            } else {
                newColumn.isSorted = false;
                newColumn.isSortedDescending = true;
            }
        });
        newItems = this._sortItems(newItems, currentColumn.fieldName, currentColumn.isSortedDescending);
        this.setState({
            columns: newColumns
        });
        this.props.actionsCreator.afterSortAttachments(newItems);
        if (currentColumn.isSortedDescending) {
            announce(Utils_String.format(Resources.AnnounceSortedDesc, currentColumn.fieldName));
        } else {
            announce(Utils_String.format(Resources.AnnounceSortedAsc, currentColumn.fieldName));
        }
    }

    private _onColumnHeaderClickForLogStore = (ev: any, column: IColumn) => {
        const { columns, attachments } = this.state;
        let newItems: TCMContracts.TestLog[] = attachments.getLogStoreAttachments().slice();
        let newColumns: IColumn[] = this._columnsForLogStore.slice();
        let currentColumn: IColumn = newColumns.filter((currCol: IColumn, idx: number) => {
            return column.key === currCol.key;
        })[0];
        newColumns.forEach((newColumn: IColumn) => {
            if (newColumn === currentColumn) {
                currentColumn.isSortedDescending = !currentColumn.isSortedDescending;
                currentColumn.isSorted = true;
            } else {
                newColumn.isSorted = false;
                newColumn.isSortedDescending = true;
            }
        });
        newItems = this._sortItemsForLogStore(newItems, currentColumn.fieldName, currentColumn.isSortedDescending);
        this.setState({
            columns: newColumns
        });
        this.props.actionsCreator.afterSortAttachmentsForLogStore(newItems);
        if (currentColumn.isSortedDescending) {
            announce(Utils_String.format(Resources.AnnounceSortedDesc, currentColumn.fieldName));
        } else {
            announce(Utils_String.format(Resources.AnnounceSortedAsc, currentColumn.fieldName));
        }
    }

    private _sortItems = (items: TCMContracts.TestAttachment[], sortBy: string, descending = false): TCMContracts.TestAttachment[] => {
        if (descending) {
            return items.sort((a: TCMContracts.TestAttachment, b: TCMContracts.TestAttachment) => {
                if (a[sortBy] < b[sortBy]) {
                    return 1;
                }
                if (a[sortBy] > b[sortBy]) {
                    return -1;
                }
                return 0;
            });
        } else {
            return items.sort((a: TCMContracts.TestAttachment, b: TCMContracts.TestAttachment) => {
                if (a[sortBy] < b[sortBy]) {
                    return -1;
                }
                if (a[sortBy] > b[sortBy]) {
                    return 1;
                }
                return 0;
            });
        }
    }

    private _sortItemsForLogStore = (items: TCMContracts.TestLog[], sortBy: string, descending = false): TCMContracts.TestLog[] => {
        if (descending) {
            return items.sort((a: TCMContracts.TestLog, b: TCMContracts.TestLog) => {
                if (sortBy == "filePath") {
                    if (Utils_File.getFileName(a.logReference[sortBy]) < Utils_File.getFileName(b.logReference[sortBy])) {
                        return 1;
                    }
                    if (Utils_File.getFileName(a.logReference[sortBy]) > Utils_File.getFileName(b.logReference[sortBy])) {
                        return -1;
                    }
                }
                else {
                    if (a[sortBy] < b[sortBy]) {
                        return 1;
                    }
                    if (a[sortBy] > b[sortBy]) {
                        return -1;
                    }
                }
                return 0;
            });
        } else {
            return items.sort((a: TCMContracts.TestLog, b: TCMContracts.TestLog) => {
                if (sortBy == "filePath") {
                    if (Utils_File.getFileName(a.logReference[sortBy]) < Utils_File.getFileName(b.logReference[sortBy])) {
                        return -1;
                    }
                    if (a.logReference[sortBy] > b.logReference[sortBy]) {
                        return 1;
                    }
                }
                else {
                    if (a[sortBy] < b[sortBy]) {
                        return -1;
                    }
                    if (a[sortBy] > b[sortBy]) {
                        return 1;
                    }
                }
                return 0;
            });
        }
    }

    private _createContextMenu(attachment: TCMContracts.TestAttachment, index: number): JSX.Element {
        let items: IContextualMenuItem[] = [];

        let isDeleteDisabled = false;
        if (this.props.attachmentSource === TMUtils.AttachmentSource.testRun) {
            isDeleteDisabled = true;
        }

        let isPreviewDisabled = false;
        if (!TMUtils.getTestResultManager().isAttachmentPreviewable(attachment.fileName)) {
            isPreviewDisabled = true;
        }

        items =
            [
                {
                    key: "previewAttachment",
                    onClick: () => {
                        this._previewItem(this.state.selectionDetails[0]);
                    },
                    disabled: isPreviewDisabled,
                    iconProps: {
                        iconName: "DocumentSearch"
                    },
                    name: Resources.PreviewText
                },
                {
                    key: "saveAttachment",
                    onClick: () => {
                        this.props.actionsCreator.downloadSelectedAttachments(this.state.selectionDetails, this.props.attachmentSource, this.props.testRunId, this.props.testResultId, this.props.subResultId);
                    },
                    iconProps: {
                        iconName: "Download"
                    },
                    name: Resources.Download
                },
                {
                    key: "deleteAttachment",
                    onClick: () => {
                        this._confirmDeletion();
                    },
                    disabled: isDeleteDisabled,
                    iconProps: {
                        iconName: "ChromeClose",
                    },
                    name: Resources.DeleteText
                },
            ];

        let showContextMenu = false;
        if (this.state.contextMenuOpenIndex === index) {
            showContextMenu = true;
            this.props.actionsCreator.updateContextMenuOpenIndex(-1);
        }

        let contextMenuProps: IPopupContextualMenuProps = {
            className: "context-menu grid-context-menu",
            iconClassName: "bowtie-ellipsis",
            items: items,
            menuClassName: "processes-popup-menu",
            showContextMenu: showContextMenu,
            onClick: (event) => { this._onContextMenuClick(attachment, index, event); },
            onDismiss: this._onDismissContextMenu
        };
        return <PopupContextualMenu {...contextMenuProps} />;
    }

    private _createContextMenuForLogStore(attachment: TCMContracts.TestLog, index: number): JSX.Element {
        let items: IContextualMenuItem[] = [];

        items =
            [
                {
                    key: "saveAttachment",
                    onClick: () => {
                        this.props.actionsCreator.downloadSelectedAttachmentsForLogStore(this.state.logStoreSelectionDetails, this.props.attachmentSource);
                    },
                    iconProps: {
                        iconName: "Download"
                    },
                    name: Resources.Download
                }
            ];

        let showContextMenu = false;
        if (this.state.contextMenuOpenIndex === index) {
            showContextMenu = true;
            this.props.actionsCreator.updateContextMenuOpenIndex(-1);
        }

        let contextMenuProps: IPopupContextualMenuProps = {
            className: "context-menu grid-context-menu",
            iconClassName: "bowtie-ellipsis",
            items: items,
            menuClassName: "processes-popup-menu",
            showContextMenu: showContextMenu,
            onClick: (event) => { this._onContextMenuClickForLogStore(attachment, index, event); },
            onDismiss: this._onDismissContextMenu
        };
        return <PopupContextualMenu {...contextMenuProps} />;
    }

    private _onItemInvoked = (item: TCMContracts.TestAttachment, ev?: any): void => {
        if (ev && ev.keyCode === Utils_UI.KeyCode.ENTER || !ev) {
            if (TMUtils.getTestResultManager().isAttachmentPreviewable(item.fileName)) {
                this.props.actionsCreator.openPreviewDialog(this.props.testRunId, this.props.testResultId, this.props.subResultId, this.props.attachmentSource, item);

                let fileNameExtension: string = this.props.actionsCreator.getFilenameExtension(item.fileName);

                TelemetryService.publishEvents(TelemetryService.featureAttachmentsGridView_PreviewAttachment,
                    {
                        "AttachmentSource": this.props.attachmentSource,
                        "PreviewAction": "DoubleClickAndPreview",
                        "AttachmentType": fileNameExtension,
                        "SizeInKB": Math.ceil(item.size / 1024)
                    });
            } else {
                this.props.actionsCreator.downloadSelectedAttachments([item], this.props.attachmentSource, this.props.testRunId, this.props.testResultId, this.props.subResultId);
            }
        }
    }

    private _onItemInvokedForLogStore = (item: TCMContracts.TestLog, ev?: any): void => {
        if (ev && ev.keyCode === Utils_UI.KeyCode.ENTER || !ev) {
            
            this.props.actionsCreator.downloadSelectedAttachmentsForLogStore([item], this.props.attachmentSource);
            
        }
    }

    private _previewItem = (item: TCMContracts.TestAttachment): void => {
        let fileNameExtension: string = this.props.actionsCreator.getFilenameExtension(item.fileName);

        TelemetryService.publishEvents(TelemetryService.featureAttachmentsGridView_PreviewAttachment,
            {
                "AttachmentSource": this.props.attachmentSource,
                "PreviewAction": "ContextMenuAndPreview",
                "AttachmentType": fileNameExtension,
                "SizeInKB": Math.ceil(item.size / 1024)
            });
        this.props.actionsCreator.openPreviewDialog(this.props.testRunId, this.props.testResultId, this.props.subResultId, this.props.attachmentSource, item);
    }

    private _deleteAttachments(): void {
        this.props.actionsCreator.deleteResultAttachments(this.props.testRunId, this.props.testResultId, this.props.attachmentSource, this.state.selectionDetails);
    }

    private _confirmDeletion(): void {
        let attachmentsNameList: string = " ";
        this.state.selectionDetails.forEach((attachment) => {
            attachmentsNameList = attachmentsNameList + attachment.fileName + " ";
        });
        ConfirmationDialog.openConfirmationDialog(Utils_String.format(Resources.ConfirmAttachmentDeletion, attachmentsNameList), () => { this._deleteAttachments(); });
    }

    private _handleStoreChange = (): void => {
        this.setState(this.props.store.getState());
    }

    private _onContextMenuClick = (item?: any, index?: number, ev?: any) => {
        let isIndexInSelected: boolean = false;
        if (this.state.selectionDetails != null) {
            this.state.selectionDetails.forEach((attachment) => {
                if (item.id === attachment.id) {
                    isIndexInSelected = true;
                }
            });
            if (this.state.selectionDetails.length > 1 && isIndexInSelected) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
        this.props.actionsCreator.updateContextMenuOpenIndex(index);
        this.forceUpdate();
    }

    private _onContextMenuClickForLogStore = (item?: any, index?: number, ev?: any) => {
        let isIndexInSelected: boolean = false;
        if (this.state.logStoreSelectionDetails != null) {
            this.state.logStoreSelectionDetails.forEach((attachment) => {
                if (item.logReference.subResultId === attachment.logReference.subResultId && item.logReference.resultId === attachment.logReference.resultId && item.logReference.runId === attachment.logReference.runId) {
                    isIndexInSelected = true;
                }
            });
            if (this.state.logStoreSelectionDetails.length > 1 && isIndexInSelected) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
        this.props.actionsCreator.updateContextMenuOpenIndex(index);
        this.forceUpdate();
    }

    private _onItemContextMenu = (item?: any, index?: number, ev?: any) => {
        $(".context-menu").eq(index).find(".popup-menu-trigger").click();
    }

    private _onDismissContextMenu = () => {
        this.props.actionsCreator.updateContextMenuOpenIndex(-1);
        this.forceUpdate();
    }

    private _getColumnsForDetailsList = () : IColumn[] => {
        const _columns: IColumn[] = [
            {
                key: "attachmentName",
                name: Resources.Name,
                fieldName: "fileName",
                minWidth: 210,
                maxWidth: 350,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: this._onColumnHeaderClick,
                data: "string",
                isPadded: false,
                onRender: (item: TCMContracts.TestAttachment, index: number) => {
                    return (
                        <div>
                            <div className="attachment-name">
                                <TooltipHost content={item.fileName}>
                                    <span>
                                        <a role="link"
                                            onKeyDown={(ev) => this._onItemInvoked(item, ev)}
                                            onClick={() => this._onItemInvoked(item)}>
                                            {item.fileName}
                                        </a>
                                    </span>
                                </TooltipHost>
                            </div>
                            {this._createContextMenu(item, index)}
                        </div>
                    );
                }
            },
            {
                key: "attachmentSize",
                name: Resources.AttachmentSize,
                fieldName: "size",
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: "number",
                onColumnClick: this._onColumnHeaderClick,
                onRender: (item: TCMContracts.TestAttachment) => {
                    return (
                        <span>
                            {Utils_String.format(Resources.AttachmentSizeValueInKB, Math.ceil(item.size / 1024))}
                        </span>
                    );
                }
            },
            {
                key: "createdDate",
                name: Resources.DateCreated,
                fieldName: "createdDate",
                minWidth: 150,
                maxWidth: 200,
                isResizable: true,
                data: "string",
                onColumnClick: this._onColumnHeaderClick,
                onRender: (item: TCMContracts.TestAttachment) => {
                    return (
                        <TooltipHost content={item.createdDate.toString()}>
                            <span>
                                {Utils_Date.friendly(item.createdDate)}
                            </span>
                        </TooltipHost>
                    );
                }
            },
            {
                key: "comment",
                name: Resources.Comment,
                fieldName: "comment",
                minWidth: 210,
                maxWidth: 350,
                isResizable: true,
                data: "string",
                onColumnClick: this._onColumnHeaderClick,
                onRender: (item: TCMContracts.TestAttachment) => {
                    return (
                        <span>
                            {item.comment}
                        </span>
                    );
                }
            }
        ];
        return _columns;
    }

    private _getColumnsForDetailsListForLogStore = (): IColumn[] => {
        const _columns: IColumn[] = [
            {
                key: "attachmentName",
                name: Resources.Name,
                fieldName: "filePath",
                minWidth: 210,
                maxWidth: 350,
                isRowHeader: true,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: this._onColumnHeaderClickForLogStore,
                data: "string",
                isPadded: false,
                onRender: (item: TCMContracts.TestLog, index: number) => {
                    return (
                        <div>
                            <div className="attachment-name">
                                <TooltipHost content={Utils_File.getFileName(item.logReference.filePath)}>
                                    <span>
                                        <a role="link"
                                            onKeyDown={(ev) => this._onItemInvokedForLogStore(item, ev)}
                                            onClick={() => this._onItemInvokedForLogStore(item)}>
                                            {Utils_File.getFileName(item.logReference.filePath)}
                                        </a>
                                    </span>
                                </TooltipHost>
                            </div>
                            {this._createContextMenuForLogStore(item, index)}
                        </div>
                    );
                }
            },
            {
                key: "attachmentSize",
                name: Resources.AttachmentSize,
                fieldName: "size",
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: "number",
                onColumnClick: this._onColumnHeaderClickForLogStore,
                onRender: (item: TCMContracts.TestLog) => {
                    return (
                        <span>
                            {Utils_String.format(Resources.AttachmentSizeValueInKB, Math.ceil(item.size / 1024))}
                        </span>
                    );
                }
            },
            {
                key: "createdDate",
                name: Resources.DateCreated,
                fieldName: "modifiedOn",
                minWidth: 150,
                maxWidth: 200,
                isResizable: true,
                data: "string",
                onColumnClick: this._onColumnHeaderClickForLogStore,
                onRender: (item: TCMContracts.TestLog) => {
                    return (
                        <TooltipHost content={item.modifiedOn.toString()}>
                            <span>
                                {Utils_Date.friendly(item.modifiedOn)}
                            </span>
                        </TooltipHost>
                    );
                }
            }
        ];
        return _columns;
    }

    private _onErrorMessageDismiss = () => {
        this.props.actionsCreator.closeErrorMessage();
    }
}
